module.exports = __webpack_public_path__ + "img/hlrv.0609d7fc.jpeg";